import {
  addressPlaceholder,
  marriagePlaceholder,
  personPlaceholder,
} from '../constants/iterableTexts';
import { i18n } from './i18n';
import { t } from '@lingui/macro';

export function getPersonPlaceholder(
  field: keyof typeof personPlaceholder,
  inMarriage?: boolean
): string;
export function getPersonPlaceholder(
  field: 'birthCertificate',
  inMarriage?: never
): { full: string; empty: string };

export function getPersonPlaceholder(field, inMarriage = false) {
  return inMarriage
    ? `${personPlaceholder[field]} ${i18n._(t`в браке`)}`
    : personPlaceholder[field];
}

export function getAddressPlaceholder(
  field: keyof typeof addressPlaceholder
): string {
  return addressPlaceholder[field];
}

export function getMarriagePlaceholder(
  field: keyof typeof marriagePlaceholder
): string {
  return marriagePlaceholder[field];
}
